// removed by extract-text-webpack-plugin
module.exports = {"shareButton":"_33mb3YKPitpfZwSbGQz8Ad"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareFacebookButton/ShareFacebookButton.scss
// module id = 1776
// module chunks = 0